import React from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import ajax from '../../utils/ajax'
import pclnExperimentation from '@pcln/experimentation'
import exenv from 'exenv'
import { once } from 'ramda'

const config = require('isomorphic-config')
const locationConfig = config.client.typeahead.location

const memoizedImpression = [pclnExperimentation]

// TODO: HP_RC_PREVIOUS_SEARCHES seti cleanup
const getRentalCarBoostExprimentQs = () => {
  if (exenv && memoizedImpression) {
    once(() => pclnExperimentation.fireImpression('HP_RC_PREVIOUS_SEARCHES'))
  }

  return (pclnExperimentation.getTestState('HP_RC_PREVIOUS_SEARCHES') !== 'DEFAULT')
    ? '&personalizeSearch=true' : ''
}

export default Component =>
  class extends React.Component {
    static propTypes = {
      typeAhead: PropTypes.shape({
        keys: PropTypes.arrayOf(PropTypes.string).isRequired,
        endpoint: PropTypes.string.isRequired
      }).isRequired
    }

    state = this.props.typeAhead.keys.reduce((a, b) => ({ ...a, b: [] }), {})

    getEndpoint = key => {
      const { endpoint = '' } = this.props.typeAhead
      switch (endpoint) {
        case 'cars':
          return locationConfig.cars
        case 'vacations':
          return key === 'startLocation' ? locationConfig.packagesOrigin : locationConfig.packagesDestination
        case 'hotels':
        default:
          return `${locationConfig.general}hotels/`
      }
    }

    getEndpointSuffix = () => {
      const { endpoint = '' } = this.props.typeAhead
      switch (endpoint) {
        case 'hotels':
          return locationConfig.suffix.hotels
        case 'vacations':
          return locationConfig.suffix.packages
        default:
          return ''
      }
    }

    getLocations = key => {
      const query = get(this.props, `values.${key}`)
      if (!query) return

      const endpoint = this.getEndpoint(key)
      const parsedURLSuffix = this.getEndpointSuffix()

      const isRCSearchEndPoint = endpoint === locationConfig.cars

      const parseURLSuffixQS = isRCSearchEndPoint ? `${locationConfig.querystring.cars}${getRentalCarBoostExprimentQs()}` : ''

      const url = `${endpoint}${query}${parsedURLSuffix}${parseURLSuffixQS}`

      return ajax({ url })
        .then(({ data: { searchItems = [] } }) => {
          const options = searchItems.map(option => {
            return {
              ...option,
              content: option.itemName
            }
          })
          this.setState(state => ({
            [key]: options
          }))
        })
        .catch(err => {
          // TODO: log
          // eslint-disable-line no-console
          console.error(err)
        })
    }

    // prev is an object of key: value where key is the name
    // of the typeahead field and value is the current value of the input
    onTypeaheadKeyUp = (prev) => {
      this.props.typeAhead.keys.forEach(key => {
        if ((get(prev, `values.${key}`) === get(this.props, `values.${key}`))) {
          return
        }
        this.getLocations(key)
      })
    }

    render () {
      return <Component {...this.props} typeAheadOptions={this.state} onTypeaheadKeyUp={this.onTypeaheadKeyUp} />
    }
  }
